const projectsFilters = {

    init () {

        let body = document.body;
        let filtersButton = document.querySelector('.filters-button');
        let filtersDropdown = document.querySelector('.filters-dropdown');
        let filtersHeader = document.querySelector('.filters-header');

        if(filtersButton){
          
            filtersButton.addEventListener('click', function(){
                filtersButton.classList.toggle('active-menu');
                filtersDropdown.classList.toggle('active-menu');
                filtersHeader.classList.toggle('active-menu');
                body.classList.toggle('noscroll');

                if(filtersButton.classList.contains('active-menu')){
                    filtersButton.innerHTML = 'FERMER';
                } else {
                    filtersButton.innerHTML = 'FILTRER';
                }

            });

        }

    }

}

export default projectsFilters;